import { Component, Input } from '@angular/core';
import { ClientChore } from 'app/core/models/client-chore.model';
import { TitleCasePipe } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-client-chore-status',
    templateUrl: './client-chore-status.component.html',
    styleUrls: ['./client-chore-status.component.scss'],
    imports: [NgbPopover, TitleCasePipe]
})
export class ClientChoreStatusComponent {
  @Input() clientChore: ClientChore;

  onNoteClick($event: MouseEvent) {
    $event.preventDefault();
  }
}
